// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"7d8a9e95","605":"29e4ca2a","753":"17c21a8d","981":"454b3a33"}[chunkId] + ".chunk.js";
};